var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPodiumPurple = function SvgIconPodiumPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.403 4.4017C4.92039 4.4017 5.4166 4.19616 5.78246 3.83031C6.14831 3.46445 6.35385 2.96825 6.35385 2.45085C6.35385 1.93345 6.14831 1.43725 5.78246 1.07139C5.4166 0.705535 4.92039 0.5 4.403 0.5C3.8856 0.5 3.38939 0.705535 3.02354 1.07139C2.65768 1.43725 2.45215 1.93345 2.45215 2.45085C2.45215 2.96825 2.65768 3.46445 3.02354 3.83031C3.38939 4.19616 3.8856 4.4017 4.403 4.4017Z",
    stroke: "#533366",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79078 6.91162C6.64352 6.39427 6.33224 5.93874 5.90377 5.61356C5.4753 5.28838 4.95281 5.11113 4.41492 5.10849C3.87704 5.10585 3.35284 5.27796 2.92119 5.59892C2.48955 5.91988 2.17381 6.37233 2.02148 6.88821",
    stroke: "#533366",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.31906H8.30339",
    stroke: "#533366",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27308 12.2052L1.20898 8.31906H7.59358L6.52948 12.2052",
    stroke: "#533366",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40782 10.2699C4.36078 10.2699 4.31567 10.2512 4.28241 10.2179C4.24915 10.1847 4.23047 10.1396 4.23047 10.0925C4.23047 10.0455 4.24915 10.0004 4.28241 9.96714C4.31567 9.93388 4.36078 9.91519 4.40782 9.91519",
    stroke: "#533366"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40625 10.2699C4.45329 10.2699 4.4984 10.2512 4.53166 10.2179C4.56492 10.1847 4.5836 10.1396 4.5836 10.0925C4.5836 10.0455 4.56492 10.0004 4.53166 9.96714C4.4984 9.93388 4.45329 9.91519 4.40625 9.91519",
    stroke: "#533366"
  })));
};
export default SvgIconPodiumPurple;